// src/components/FAQSection.jsx
import React, { useState, forwardRef } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { ChevronDown, ChevronUp } from 'lucide-react';
import { Trans, useTranslation } from 'react-i18next';

const FAQSection = forwardRef(({ onContact }, ref) => {
  const { t } = useTranslation();
  const faqs = t('faq.questions', { returnObjects: true });
  const [openIndex, setOpenIndex] = useState(null);

  const toggle = (i) => {
    setOpenIndex(openIndex === i ? null : i);
  };

  return (
    <section
      ref={ref}
      id="faq"
      className="py-16 md:py-20 bg-gray-800/50"
    >
      <div className="container mx-auto px-4">
        <h2 className="text-3xl md:text-4xl font-bold text-white text-center mb-12">
          {t('faq.title')}
        </h2>
        <div className="space-y-4 max-w-3xl mx-auto">
          {faqs.map((item, i) => (
            <div key={i} className="bg-gray-700 rounded-lg overflow-hidden">
              <button
                onClick={() => toggle(i)}
                className="w-full flex justify-between items-center px-6 py-4 text-white text-left"
              >
                <span>{item.question}</span>
                {openIndex === i
                  ? <ChevronUp className="w-6 h-6 text-white" />
                  : <ChevronDown className="w-6 h-6 text-white" />
                }
              </button>

              <AnimatePresence initial={false}>
                {openIndex === i && (
                  <motion.div
                    key="content"
                    initial={{ height: 0, opacity: 0 }}
                    animate={{ height: 'auto', opacity: 1 }}
                    exit={{ height: 0, opacity: 0 }}
                    transition={{ duration: 0.3, ease: 'easeInOut' }}
                    className="px-6 pb-4 text-gray-300"
                  >
                    <Trans
                      i18nKey={`faq.questions.${i}.answer`}
                      components={{
                        contactLink: (
                          <button
                            onClick={onContact}
                            className="text-teal-400 hover:underline inline"
                          />
                        )
                      }}
                    />
                  </motion.div>
                )}
              </AnimatePresence>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
});

export default FAQSection;
